import { TUNING } from '../config/tuning.js';

const L = TUNING.life;

/**
 * How "old" the player is in gameplay terms: 0 at the start of life … 1 at retirement.
 * Follows `life.agingCurve`, so agility (and the gates adapting to it) change late in life,
 * while the visible age moves linearly with the progress bar.
 */
export function agingAt(progress: number): number {
  return Math.pow(Math.min(1, Math.max(0, progress)), L.agingCurve);
}

/** Age in years for a life progress of 0…1. */
export function ageAt(progress: number): number {
  return Math.round(L.startAge + (L.endAge - L.startAge) * Math.min(1, Math.max(0, progress)));
}

/** Linear interpolation between `young` and `old` by the aging factor (0…1). */
export function byAging(young: number, old: number, aging: number): number {
  return young + (old - young) * aging;
}
